const AUDIT_EVENTS = [
  {
    title: 'Sarah Khumalo · cybersecurity enrolment auto-queued',
    actor: 'OnboardOS AI',
    date: '12 May',
    time: '09:14',
    tone: 'info',
    icon: 'bi-info-circle'
  },
  {
    title: 'ABC Tech · evidence request sent',
    actor: 'P. Naidoo',
    date: '12 May',
    time: '09:01',
    tone: 'warning',
    icon: 'bi-exclamation-circle'
  },
  {
    title: 'Lulama Trading · activated (synced to Complyon)',
    actor: 'T. Reddy',
    date: '12 May',
    time: '08:33',
    tone: 'success',
    icon: 'bi-check-circle'
  },
  {
    title: 'NewGX Capital · DoA-014 triggered → CEO',
    actor: 'Rules engine',
    date: '11 May',
    time: '17:45',
    tone: 'warning',
    icon: 'bi-exclamation-circle'
  },
  {
    title: 'Moyo Electronics · category review queued',
    actor: 'Rules engine',
    date: '11 May',
    time: '14:12',
    tone: 'warning',
    icon: 'bi-exclamation-circle'
  },
  {
    title: 'ABC Tech · tax certificate marked expired',
    actor: 'SARS connector',
    date: '11 May',
    time: '06:00',
    tone: 'danger',
    icon: 'bi-x-circle'
  }
];

export default {
  name: 'OnboardingAuditLog',
  data: () => ({
    audit_events: AUDIT_EVENTS
  }),
  methods: {
    marker_class(tone) {
      return `audit-log-timeline__marker--${tone}`;
    }
  }
};
